<template>
  <div class="bg__whiteAbs">
    <div class="how--to">
      <div class="ly--outer--container">
        <div
          class="h1 text-center txt-upper mB24 section__title"
          v-html="$t('howToUse.title')"
        ></div>

        <div class="">
          <div class="d-none d-md-block">
            <div class="row how--to__img--row">
              <div class="col" v-for="(item, index) in howToData" :key="index">
                <div class="how--to__img--col">
                  <ImageWrapper
                    :src="`https://s3.ap-southeast-1.amazonaws.com/nespresso.web/vertuo_pop/assets/images/${item.img}`"
                    class="how--to__img"
                    alt=""
                  />

                  <div class="col__whiteAbs how--to__img--txt">
                    <div class="h1 mB4">0{{ index + 1 }}</div>
                    <div class="h3 fw-bold txt-upper" v-html="item.txt"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="d-block d-md-none how--to__swiper">
            <Swiper
              :options="options"
              ref="storySlider"
              @slide-change="handleActiveChange"
            >
              <SwiperSlide v-for="(item, index) in howToData" :key="index">
                <div class="how--to__img--col">
                  <ImageWrapper
                    :src="`https://s3.ap-southeast-1.amazonaws.com/nespresso.web/vertuo_pop/assets/images/${item.img}`"
                    class="how--to__img"
                    alt=""
                  />

                  <div class="col__whiteAbs how--to__img--txt">
                    <div class="h1 mB4">0{{ index + 1 }}</div>
                    <div class="h3 fw-bold txt-upper" v-html="item.txt"></div>
                  </div>
                </div>
              </SwiperSlide>
              <div class="swiper-pagination" slot="pagination"></div>
            </Swiper>
          </div>
        </div>
      </div>
    </div>

    <div class="features">
      <div class="ly--outer--container">
        <div
          class="h1 text-center txt-upper section__title features__title"
          v-html="$t('feature.title')"
        ></div>
        <div class="row">
          <div
            class="col-6 col-md"
            v-for="(item, index) in featureDetails"
            :key="index"
          >
            <div class="features__col">
              <Icons :name="item.icon" class="features__icon" />
              <p class="body-large text-center fw-bold" v-html="item.txt"></p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="like--to">
      <div class="ly--outer--container">
        <div
          class="h1 text-center txt-upper section__title features__title"
          v-html="$t('suggestion.title')"
        ></div>

        <div>
          <div class="row like--to__row">
            <div
              class="col-12 col-md-12 col-lg-6"
              v-for="(item, index) in suggestions"
            >
              <a class="like--to__col" :href="item.link" target="_blank">
                <span class="row gx-0">
                  <div class="col-auto">
                    <ImageWrapper
                      class="like--to__img"
                      :src="`https://s3.ap-southeast-1.amazonaws.com/nespresso.web/vertuo_pop/assets/images/${item.img}`"
                      alt=""
                    />
                  </div>
                  <div class="col like--to__txt">
                    <span
                      class="h2 fw-bold like--to__content"
                      v-html="item.txt"
                    ></span>

                    <Icons
                      name="arrow_gold"
                      class="d-block d-md-none like--to__icon"
                    ></Icons>
                  </div>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icons from "../atoms/Icons.vue";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import { ImageWrapper } from "~/components/";

export default {
  name: "HomeHowTo",
  components: { Icons, Swiper, SwiperSlide, ImageWrapper },

  data() {
    return {
      slides: [], //children slides
      activeIndex: 0,

      options: {
        spaceBetween: 20,
        slidesPerView: 1.2,
        centeredSlides: false,
        loop: false,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
    };
  },

  methods: {
    handleActiveChange() {
      console.log(this.swiper.activeIndex);
      this.activeIndex = this.swiper.activeIndex;
    },
  },

  computed: {
    howToData() {
      return this.$t("howToUse.steps");
    },

    featureDetails() {
      return this.$t("feature.details");
    },

    suggestions() {
      return this.$t("suggestion.details");
    },
  },
};
</script>

<style lang="scss">
@import "~/scss/include/_commonInclude.scss";
.content .app {
  .how--to {
    padding: rem(40) 0;

    &__swiper {
      margin-right: -20px;
      overflow: hidden;

      .swiper-wrapper {
        padding-bottom: rem(50);
      }

      .swiper-pagination-bullet {
        background-color: #dcd9cc;
        opacity: 1 !important;
      }

      .swiper-pagination-bullet-active {
        background-color: #f5b31e;
        transform: scale(1.3);
      }
    }

    &__img {
      width: 100%;
      height: 100%;
      object-fit: cover;

      &--txt {
        position: relative;
      }

      &--col {
        aspect-ratio: 386/217 * 1;
        position: relative;
        border-radius: rem(16);
        overflow: hidden;
        padding: rem(24);

        img {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
        }
      }

      &--row.row {
        --bs-gutter-x: #{rem(16)};
      }
    }
  }

  .features {
    padding: rem(40) 0;

    &__title {
      margin-bottom: rem(64);
    }

    &__icon {
      width: rem(55);
      height: rem(88);
      object-fit: contain;
    }

    &__col {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  .like--to {
    padding: rem(40) 0;
    background-image: url("https://s3.ap-southeast-1.amazonaws.com/nespresso.web/vertuo_pop/assets/images/homehowto-bg.png");
    background-repeat: no-repeat;
    background-position-y: bottom;
    background-position-x: center;

    @include media-breakpoint-down(md) {
      background-position-y: 78%;
    }

    &__icon {
      width: rem(32);
      aspect-ratio: 1;
      object-fit: contain;
      margin-left: rem(32);
    }

    &__col {
      display: flex;
      box-shadow: 0 10px 16px 0 rgba(0, 0, 0, 0.2),
        0 6px 20px 0 rgba(213, 210, 199, 0.25) !important;
      border-radius: rem(10);
      height: 100%;
      overflow: hidden;
      color: color(black);

      > .row {
        width: 100%;
      }
    }

    &__content {
      @include media-breakpoint-down(md) {
        font-size: rem(16);
        line-height: 1.1em;
      }
    }

    &__txt {
      display: flex;
      align-items: center;

      padding: rem(20) rem(40);

      @include media-breakpoint-down(md) {
        padding: rem(24);
      }

      justify-content: space-between;
      width: 100%;
      background-color: white;
    }

    &__img {
      width: rem(200);
      height: 100%;
      object-fit: cover;

      @include media-breakpoint-down(lg) {
        width: rem(120);
      }
    }

    &__row.row {
      --bs-gutter-x: #{rem(16)};
      --bs-gutter-y: #{rem(16)};
    }
  }
}
</style>
